import { ChangeEvent, ReactElement } from "react";
import { AppIconButton } from "../../../../shared/components/AppIconButton";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "./styles.module.css";

interface Props {
  icon: ReactElement | null;
  type: "icon_button" | "button";
  handleFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  inputRef?: React.Ref<HTMLInputElement>;
  styleType?: "text" | "contained" | "outlined";
  multiple?: boolean;
  title?: string;
  className?: string;
}

export const UploadFileButton = (props: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  if (props.type === "icon_button") {
    return (
      <AppIconButton
        onClick={handleClick}
        component="label"
        buttonType={props.styleType}
        className={props.className}
      >
        <input
          ref={props.inputRef}
          className={styles["upload-input"]}
          type="file"
          multiple={props.multiple}
          onChange={props.handleFileUpload}
        />
        {props.icon}
      </AppIconButton>
    );
  }

  return (
    <AppButton
      component="label"
      onClick={handleClick}
      buttonType={props.styleType ?? "text"}
      icon={props.icon ? props.icon : null}
      className={props.className}
    >
      <input
        ref={props.inputRef}
        className={styles["upload-input"]}
        type="file"
        onChange={props.handleFileUpload}
        multiple={props.multiple}
        onClick={(e: any) => {
          e.target.value = null;
          e.stopPropagation();
        }}
      />
      {props.title}
    </AppButton>
  );
};
